
import { at } from 'lodash';
import { useField, Form, FormikProps, Formik } from 'formik';
import TextField from '@mui/material/TextField';

export default function TextAreaField(props:any) {

    
  const { errorText, ...rest } = props;
  const [field, meta, isdisabled] = useField(props);
  


  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
   
    if (touched && error) {
        return error;
    }
    if (touched && props.required && (!field.value || field.value === '')) {
        return "Campo requerido";
    }
  }

  return (
    <TextField
      multiline
      autoComplete="off"
      error={Boolean((meta.touched && meta.error) || (meta.touched && props.required && (!field.value || field.value === '')))}
      helperText={_renderHelperText()}
      rows={5}
      {...field}
      {...rest}
    />
  );
}